import React, {useEffect, useState, useRef} from "react";
import {connect} from "react-redux";
import styled from "styled-components";
import {AppearFromBottom} from "global/style";
import {GoogleApiWrapper, InfoWindow, Map} from "google-maps-react";
import {settingsActions} from "../../../../_actions/settings.actions";
import Marker from "./Components/Marker.Map";
import Icons from "../../Utility/Icons";
import InfoBox from "./Components/InfoBox.Map";
import ReactDOM from "react-dom";
import {translate, language} from "_helpers/general.helper";
import { sendRequest } from '_helpers/request.helper';

//   for reference: https://stackoverflow.com/questions/53615413/how-to-add-a-button-in-infowindow-with-google-maps-react
  function InfoWindowEx(props) {
    const infoWindowRef = React.createRef();
    const contentElement = document.createElement(`div`);
    useEffect(() => {
      ReactDOM.render(React.Children.only(props.children), contentElement);
      infoWindowRef.current.infowindow.setContent(contentElement);
    }, [props.children]);
    return <InfoWindow ref={infoWindowRef} {...props} />;
  }

const MapContainer = styled(AppearFromBottom)`
  position: relative;
  height: 215px;
  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakXsmall}) {
    height: 215px;
	overflow:hidden;
	border-radius:15px;
	-moz-border-radius:15px;
	-webkit-border-radius:15px;
	-o-border-radius:15px;
  }
  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakSmall}) {
    height: 300px;
  }
  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakMedium}) {
    height: 350px;
  }
  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakLaptop}) {
    height: 430px;
  }
`;

const InfoWindowContainer = styled.div`
  padding-right: 12px;
  padding-bottom: 12px;
`;
const InfoBoxHeading = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  font-size: ${(props) => props.isNearbyProperties ? '16px' : '14px'};
  color: black;
  cursor: ${(props) => props.isNearbyProperties ? 'pointer' : 'default'}
`;

const QuickLinkUnits = styled.div`
    color: white;
    background: #42accd;
    border-radius: 15px;
    text-align: center;
    font-size: 12px;
    padding: 2px;
`

const InfoBoxAddress = styled.div`
    color: #6c757d !important;
    text-align: center;
    font-size: 10px;
`

function GoogleMap({data, scroll, google, tid, userId, storeMapPins, propertyType}) {
  const [places, setPlaces] = useState([]);
  const [fitToScreen, setFitToScreen] = useState(false);
  const [selectedPlace, setSelectedPlace] = useState(null);
  const map = useRef(); 

  const placesService = new window.google.maps.places.PlacesService(
    document.createElement("div")
  );

  const center = {
    lat: parseFloat(data[0].location.map_latitude),
    lng: parseFloat(data[0].location.map_longitude),
  };

  const customPointOfInterestStyle = [
    {
        featureType: "poi",
        elementType: "labels",
        stylers: [
              { visibility: "off" }
        ]
    }
  ];

  const getOneNearbyResult = (type, location) => {
    let newPlacesList = [];

    let radius = location.map_search_radius;
    if (location.map_search_radius_type === "miles") {
      radius = (radius * 1609.344).toFixed(2);
    }
    const req = {
      location: center,
      radius,
      type,
    };
    return new Promise((resolve, reject) => {
      placesService.nearbySearch(req, (newPlaces, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          newPlacesList = [
            ...newPlacesList,
            ...newPlaces.map((place) => ({...place, type})),
          ];
          resolve(newPlacesList)
        } else {
            reject({error: `Failed fetching pins for type: ${type}`})
        }
      });
    })
  }

  const getAllNearbyResults = (types, location) => {
    const promises = types.map((type) => getOneNearbyResult(type, location));
      Promise.allSettled(promises).then(results => {
        let pins = [];
        results.forEach((el) => {
            if (el.status != 'rejected') {
                pins = [...pins, ...el.value];
            }
        });

        setPlaces([...places, ...pins]);
        storeMapPins(pins);
      }).catch(e => {
        // if promise for fetching nearby places pins fails do nothing
      });
  }


  useEffect(() => {
    const {types, location, custom_locations, autosaved, fitToScreen} = data[0];
    if(!autosaved){
      getAllNearbyResults(types, location)
    }else{
      setPlaces([...places, ...custom_locations]);
    }
    if(fitToScreen){
      setFitToScreen(true);
    }
    return () => setPlaces([]);
  }, []);

  const selectPlace = (place, marker) => {
    setSelectedPlace({
      place: places.filter((el) => el.name === marker.name)[0],
      marker,
    });
  };

  const deselectPlace = () => {
    setSelectedPlace(null);
  };

  // If Map is ready to use, scroll to bottom and zoom out to fit all markers
  const ready = (mapProps, map) => {
    scroll('smooth');
    if (fitToScreen){
      const { google } = mapProps;
      let bounds = new window.google.maps.LatLngBounds();
      bounds.extend(center)
      places.map(place => {
        bounds.extend({
          lat: parseFloat(place.lat),
          lng: parseFloat(place.lng)
        });
      });
      map.fitBounds(bounds);
    }
  };

  const handleClick = (selectedPlace) => {
    const nearbyTid = selectedPlace?.place.tid;
    if (nearbyTid != undefined) {
        let floorplanIntent = propertyType == 'Student' ? 'TermsListFloorplansConversation' : 'ListFloorplansConversation';
        // -10 unit count is a flag which indicates there is no overlapping term in the nearby property 
        // The user that is redirected to the nearby bot should select a term
        if (selectedPlace?.place.units == -10) {
            floorplanIntent = 'Terms-Search-TermsConversation'
        }
        window.open(process.env.REACT_APP_API_TRANSFER +
            window.location.host.replace(tid, nearbyTid) +
            `/${floorplanIntent}?user_id=` +
            userId, '_blank').focus();

        logOpenedNearbyProperty(tid, `NearbyPropertiesSelect-${nearbyTid}`)
    }
  };

  const logOpenedNearbyProperty = (tid, value) => {
    const url = `${process.env.REACT_APP_API_TRANSFER}${tid}.${process.env.REACT_APP_API_URL}talk`;
    let data = new FormData();
    data.append('tid', tid);
    data.append('userId', userId);
    data.append('message', value);
    data.append('language', "English");
    data.append('driver', 'web');

    sendRequest('POST', url, data).then(
        (result) => {
            // do nothing just store in conversation_log as NearbyPropertiesSelect-{tid} 
        }
    )
  }

  return (
    <MapContainer>
      <Map
        ref={map}
        google={google}
        zoom={parseInt(data[0].location.map_zoom)}
        onReady={ready}
        initialCenter={center}
        styles={customPointOfInterestStyle}
      >
        <Marker
          position={center}
          icon={{
            url:
              "data:image/svg+xml;charset=UTF-8;base64," +
              btoa(
                Icons["center"].replace(
                  /\.st0{fill:.*;}/i,
                  `.st0{fill:${data[0].location.map_property_pin_color_primary};}`
                )
              ),
          }}
        />
        {/* Property marker */}
        {places.map((place, key) => {
          if(place.available == null || place.available == 1 ) {
            return (
              <Marker
                key={`nearby-marker-${key}`}
                name={place.name}
                onClick={selectPlace}
                position={{
                  lat: place.lat || place.geometry.location.lat(),
                  lng: place.lng || place.geometry.location.lng(),
                }}
                icon={{
                  url:
                    "data:image/svg+xml;charset=UTF-8;base64," +
                    btoa(
                      Icons[place.type || place.pin] && Icons[place.type || place.pin].replace(
                        /\.st0{fill:.*;}/i,
                        `.st0{fill:${data[0].location.map_property_pin_color_secondary};}`
                      )
                    ),
                }}
              />
            );
          }
        })}
        <InfoWindowEx
          visible={!!selectedPlace}
          marker={selectedPlace?.marker}
          onClose={deselectPlace}
        >
          <InfoWindowContainer>
            <InfoBoxHeading isNearbyProperties={selectedPlace?.place.nearby_properties > 0} onClick={() => handleClick(selectedPlace)}>{selectedPlace?.place.name}</InfoBoxHeading>
            <InfoBoxAddress>{selectedPlace?.place.map_address}</InfoBoxAddress>
            {selectedPlace?.place.units > 0 &&
                <QuickLinkUnits>
                  {selectedPlace?.place.units} {translate(selectedPlace?.place.units > 1 ? 'Units available' : 'Unit available', language(tid))}
                </QuickLinkUnits>
            }
          </InfoWindowContainer>
        </InfoWindowEx>
      </Map>
      {(!selectedPlace?.place?.nearby_properties &&
      !!selectedPlace && <InfoBox place={selectedPlace.place} mark={data[0].mark}/>
        )}
    </MapContainer>
  );
}

const mapStateToProps = (state) => ({
  tid: state.settings.tid,
  userId: state.settings.userId,
  propertyType: state.property.property_type
});

const actions = {
  scroll: settingsActions.setScroll,
  storeMapPins: settingsActions.storeMapPins,
};

const ConnectedPage = connect(mapStateToProps, actions)(GoogleMap);

const GoogleWrapper = GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  libraries: ["places"],
})(ConnectedPage);

export default GoogleWrapper;
